import { getTranslations } from 'next-intl/server';

import Title from './ListTitle';
import Section from './Section';

export default async function NewsletterSkeleton({
  locale,
}: {
  locale: string;
}) {
  const t = await getTranslations({
    locale,
    namespace: 'footer.newsletter',
  });

  return (
    <Section>
      <Title>{t('title')}</Title>
      <div className="flex flex-col mb-5 xl:flex-row gap-y-3">
        <div className="lg:mr-5 md:min-w-[200px]">{t('description')}</div>
        <form className="flex flex-col md:flex-row md:items-center">
          <div className="min-h-12 lg:max-w-[300px] mb-4 md:mr-5 md:mb-0 md:w-96 bg-white animate-pulse rounded" />
          <div className="min-h-12 lg:max-w-[350px] bg-white lg:w-96 animate-pulse rounded" />
          <button
            data-testid="newsletter-submit-btn"
            className="self-end w-40 h-12 mt-4 border-2 border-white rounded-full md:self-auto md:mt-0 sm:ml-5 xl:px-10 hover:bg-white hover:text-teal-40"
            type="submit"
            disabled
          >
            {t('sign-up-button')}
          </button>
        </form>
      </div>
    </Section>
  );
}
